import { IModel, IPoint } from "makerjs";
import { makerjs } from "../../../../source/js/shared/rendering/makerjs";

export default class LabelCaption {
	private readonly startPoint: IPoint;
	private readonly label: string;

	constructor(startPoint: IPoint, label: string) {
		this.startPoint = startPoint;
		this.label = label;
	}

	getModel(): IModel {
		const model = {} as IModel;
		const startPoint = [ this.startPoint[0], this.startPoint[1] + 25 ];
		makerjs.model.addCaption(model, this.label, startPoint);

		return model;
	}
}
